module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addFile commonMedical",
    attrs: {
      "updateFileList": _vm.updateFileList,
      "updatePicList": _vm.updatePicList
    }
  }, [_c('div', {
    staticClass: "addCourseware"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "filelist"
  }, _vm._l((_vm.FileList), function(file, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.fileClick(index, _vm.FileList)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }]
    }, [_c('div', {
      staticClass: "exapleImg hover_Img"
    }, [_c('img', {
      staticClass: "example-image",
      attrs: {
        "src": file.imgurl
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(file.attach_name))])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "addOther"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "filelist"
  }, _vm._l((_vm.PicList), function(file, index) {
    return _c('li', [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (true),
        expression: "true"
      }]
    }, [_c('div', {
      staticClass: "exapleImg"
    }, [_c('a', {
      staticClass: "example-image-link",
      attrs: {
        "href": file.fileurl,
        "data-lightbox": "example-1"
      }
    }, [_c('img', {
      staticClass: "example-image",
      attrs: {
        "src": file.fileurl
      }
    })])]), _vm._v(" "), _c('b', [_vm._v(_vm._s(file.attach_name))])])])
  }), 0)]), _vm._v(" "), _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.filePop,
      "title": '',
      "width": '980px'
    },
    on: {
      "closePop": _vm.closeFile
    }
  }, [_c('div', {
    staticClass: "altit"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("暂不支持预览，请点击下载")]), _vm._v(" "), _c('a', {
    staticClass: "downLoad",
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("下载")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addCourseBtn"
  }, [_c('p', [_vm._v("文档类型：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addCourseBtn"
  }, [_c('p', [_vm._v("其他图片：")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6ba5e31b","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/upload/uploadDetail.vue
// module id = 580
// module chunks = 1 2 3 4 5 6 7 8